<template>
	<section class="heard">
		<img src="./img/icon1.png" />
		<span v-text="name" />
		<a class="more"></a>
		<a class="message"></a>
	</section>
</template>

<script>
	export default {
		data() {
			return {
				name: this.UTILS.getParam('name')
			}
		},
		mounted: function() {
			let self = this;
			
		},
		methods: {

		}
	}
</script>

<style scoped>
.heard{ height: 1.12rem; line-height: 0.92rem; padding: 0.2rem 0.3rem 0 0.48rem;}
.heard img{ height: 0.92rem; height: 0.92rem; border-radius: 0.46rem; float: left;}
.heard span{ font-size: 0.36rem; color: #3D3D3D; margin-left: 0.3rem;}
.message{ width: 0.7rem; height: 0.92rem; background: url(./img/icon2.png) no-repeat center; background-size: 0.4rem 0.44rem; float: right;}
.more{ width: 0.7rem; height: 0.92rem; background: url(./img/icon3.png) no-repeat center; background-size: 0.44rem 0.28rem; float: right; margin-left: 0.1rem;}
</style>
